module.exports = require("lodash/transform");